export enum langEnum {
    en = "en",
    de = "de",
    it = "it",
}

export type sidebarType = "main" | "products" | "collections" | null